import { FetchUnreadTransactionThreadMessagesForBroker } from "_graphql/queries/__generated__/FetchUnreadTransactionThreadMessagesForBroker";
import { getKavaNotifications } from "_graphql/visal/queries/unread-notification-messages";
import { useQuery } from "@apollo/client";

export const useKavaNotifications = () => {
  const { data, loading, error, ...rest } =
    useQuery<FetchUnreadTransactionThreadMessagesForBroker>(
      getKavaNotifications,
      {
        fetchPolicy: "network-only",
      }
    );

  return {
    kavaNotifications:
      data?.fetchUnreadTransactionThreadMessagesForBroker || [],
    loading,
    error,
    ...rest,
  };
};
